module.exports = __webpack_public_path__ + "static/missBeautySpa-0bbe5ffbf0e77b77ae36d12e4aac3001.png";